import Vuex from 'vuex'

export default {
    props: {
        showIfHasPermission: {
            type: Array,
            default: null
        },
        hideIfHasPermission: {
            type: Array,
            default: null
        },
        enableIfHasPermission: {
            type: Array,
            default: null
        },
        disableIfHasPermission: {
            type: Array,
            default: null
        },
        checkAllCampaigns: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        '$route': function (val, oldVal) {
            this.forceRerender();
        },
        /*'selected_campaigns' : function (val, oldVal){
            console.log(val)
            this.forceRerender();
        },*/
        /*'selected_campaign' : function (val, oldVal){
            console.log(val)
            this.forceRerender();
        }*/
    },
    computed: {
        ...Vuex.mapGetters({selected_campaigns: 'rms_ui/auth/selected_campaigns'}),
        ...Vuex.mapGetters({selected_campaign: 'rms_ui/auth/single_campaign'}),

        app() {
            return app;
        },
        showComponent() {
            if (this.showIfHasPermission && Array.isArray(this.showIfHasPermission)) {
                if (this.checkAllCampaigns) {
                    let campaign_ids = this.app.auth.user.data_campaigns.map(c => c.id);
                    return this.app.auth.user.hasPermission(this.showIfHasPermission, campaign_ids);
                } else {
                    if (this.app.activePage.multiCampaign) {
                        let campaign_ids = this.app.activeMultiCampaigns.map(c => c.id);
                        return this.app.auth.user.hasPermission(this.showIfHasPermission, campaign_ids);
                    } else {
                        return this.app.auth.user.hasPermission(this.showIfHasPermission, this.app.activeSingleCampaign);
                    }
                }
            } else if (this.hideIfHasPermission && Array.isArray(this.hideIfHasPermission)) {
                if (this.checkAllCampaigns) {
                    let campaign_ids = this.app.auth.user.data_campaigns.map(c => c.id);
                    return this.app.auth.user.hasPermission(this.hideIfHasPermission, campaign_ids);
                } else {
                    if (this.app.activePage.multiCampaign) {
                        let campaign_ids = this.app.activeMultiCampaigns.map(c => c.id);
                        return !this.app.auth.user.hasPermission(this.hideIfHasPermission, campaign_ids);
                    } else {
                        return !this.app.auth.user.hasPermission(this.hideIfHasPermission, this.app.activeSingleCampaign);
                    }
                }
            }
            return true;
        },
        enableComponent() {
            if (this.enableIfHasPermission && Array.isArray(this.enableIfHasPermission)) {
                if (this.checkAllCampaigns) {
                    let campaign_ids = this.app.auth.user.data_campaigns.map(c => c.id);
                    return this.app.auth.user.hasPermission(this.enableIfHasPermission, campaign_ids);
                } else {
                    if (this.app.activePage.multiCampaign) {
                        let campaign_ids = this.app.activeMultiCampaigns.map(c => c.id);
                        return this.app.auth.user.hasPermission(this.enableIfHasPermission, campaign_ids);
                    } else {
                        return this.app.auth.user.hasPermission(this.enableIfHasPermission, this.app.activeSingleCampaign);
                    }
                }
            } else if (this.disableIfHasPermission && Array.isArray(this.disableIfHasPermission)) {
                if (this.checkAllCampaigns) {
                    let campaign_ids = this.app.auth.user.data_campaigns.map(c => c.id);
                    return this.app.auth.user.hasPermission(this.disableIfHasPermission, campaign_ids);
                } else {
                    if (this.app.activePage.multiCampaign) {
                        let campaign_ids = this.app.activeMultiCampaigns.map(c => c.id);
                        return !app.auth.user.hasPermission(this.disableIfHasPermission, campaign_ids);
                    } else {
                        return !app.auth.user.hasPermission(this.disableIfHasPermission, this.app.activeSingleCampaign);
                    }
                }
            }
            return true;
        }
    },
    methods: {
        forceRerender() {
            this.componentRefresh += 1;
        }
    },
    data() {
        return {
            componentRefresh: 0,
        }
    }
};
